import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../components/Footer";
import { dashboarddata } from "../api/api";
import XMLToDITA from "./subpages/XMLToDITA";
import Wordtodita from "./subpages/Wordtodita";
import Exceltodita from "./subpages/Exceltodita";
import Adduser from "./subpages/Adduser";
import Edituser from "./subpages/Edituser";
import Deleteuser from "./subpages/Deleteuser";
import XMLtoHTML from "./subpages/XMLtoHTML";
import WordToIM from "./subpages/WordtoIm";
import WordToTb from "./subpages/WordtoTb";
import QAtoDita from "./subpages/QAtodita";
import CastOff from "./subpages/CastOff";
import CSVToWORD from "./subpages/CSVtoWord";

const Subpage = () => {
  const { pages } = useParams();
  const [selected, setSelected] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [pagesToNav, setPagesToNav] = useState(null);
  const navigate = useNavigate();
  const [apidata, setApiData] = useState();
  const [completed, setCompleted] = useState(false);
  // const [fileId, setFileId] = useState("");
  const [users, setUsers] = useState([]);
  const { fileId } = useParams();

  const currentpage = pages.toLowerCase();

  // useEffect(() => {
  //   if (Array.isArray(selected) && Array.isArray(selected[1])) {
  //     const filteredPages = selected[1].filter((items) =>
  //       ["1", "2", "3", "4", "5", "6", "7", "8"].includes(items)
  //     );
  //     setPagesToNav(filteredPages);
  //   } else {
  //     console.warn("Invalid selected structure:", selected);
  //   }
  // }, [selected]);

  // useEffect(() => {
  //   setPagesToNav(apidata?.[0].steps);
  // }, [apidata]);

  // console.log(apidata);

  const render = () => {
    switch (currentpage) {
      case "xml_to_dita":
        return <XMLToDITA />;
      case "word_to_dita":
        return <Wordtodita />;
      case "word_to_im":
        return <WordToIM />;
        case "qa_to_dita":
        return <QAtoDita />;
      case "word_to_tb":
        return <WordToTb />;
      case "excel_to_dita":
        return <Exceltodita />;
      case "xml_to_html":
        return <XMLtoHTML />;
      case "castoff":
          return <CastOff/>;
      case "csv_to_word":
          return <CSVToWORD/>;
      case "add_user":
        return <Adduser setUsers={setUsers} users={users} />;
      case "edit_user":
        return <Edituser setUsers={setUsers} users={users} />;
      case "delete_user":
        return <Deleteuser setUsers={setUsers} users={users} />;
      default:
        break;
    }
  };

  return (
    <div className="w-full flex flex-col bg-commonfill min-h-[calc(100vh-96px)] overflow-auto">
      <div className="w-full h-auto">{render()}</div>
      <div className="w-full mt-auto">
        <Footer />
      </div>
    </div>
  );
};

export default Subpage;
